import { validateINN } from "../common/ValidateRules"

export const PersonaType = Object.freeze({
  FL: { title: "Физическое лицо", value: 0 },
  UL: { title: "Юридическое лицо", value: 1 },
})

export const CaseType = Object.freeze({
  CIVIL: { title: "Гражданские", value: 0 }, // 0027
  ADMINISTRATIVE: { title: "Административные", value: 1 }, // 0028
})

export const BankType = Object.freeze({
  OTHER: { title: "Другие", value: 0 },
  SBER: { title: "СберБанк Онлайн", value: 1 }
})

export function prettyCaseType(caseType) {
  switch (caseType) {
    case CaseType.CIVIL.value:
      return "0028"
    case CaseType.ADMINISTRATIVE.value:
      return "0027"
    default:
      return ''
  }
}

export class ExpertPayment {
  constructor(json) {
    this.courtCard = json?.courtCard ?? "" // UUID
    this.personaType = json?.personaType ?? null
    this.courtCase = json?.courtCase ?? ""
    this.caseType = json?.caseType ?? null
    this.summa = json?.summa ?? null // Number
    this.payer = json?.payer ?? ""
    this.payerInn = json?.payerInn ?? ""
    this.payerKpp = json?.payerKpp ?? ""
    this.payerBill = json?.payerBill ?? ""
    this.bankBik = json?.bankBik ?? null
    this.sber = json?.sber ?? null
  }

  get isFirstFormReady() {
    if (this.personaType == PersonaType.FL.value) {
      return this.courtCard && this.payer && this.courtCase && this.caseType != null && this.summa && this.sber != null
    }
    return this.courtCard && this.personaType != null && this.courtCase && this.caseType != null && this.summa
  }

  get isSecondFormReady() {
    if (this.personaType == PersonaType.FL.value) {
      return (validateINN(this.payerInn)) && this.bankBik.length == 9 && this.payerBill.length == 20
    }
    return (validateINN(this.payerInn)) && this.bankBik.length == 9 && this.payerBill.length == 20 && this.payerKpp
  }

  cleanForm() {
    this.payer = ""
    this.payerInn = ""
    this.payerKpp = ""
    this.payerBill = ""
    this.bankBik = ""
  }
}